module.exports = __webpack_public_path__ + "img/Reports.18c22cfc.svg";